


















import {Component} from 'vue-property-decorator';
import AuthService from '@/services/AuthService';
import bus from '@/main';
import CrossMenu from '@/components/CrossMenu.vue';
import Modals from '@/components/Modals.vue';
import BaseComponent from '@/core/components/BaseComponent';
import AppUpdateNotificationView from "@/components/AppUpdateNotificationView.vue";
import SystemBar from "@/components/SystemBar/SystemBar.vue";

@Component({
    components: {
        SystemBar,
        AppUpdateNotificationView,
        Modals,
        CrossMenu
    }
})
export default class App extends BaseComponent {

    // View Bindings
    public showMenu = false;

    public created() {
        this.showMenu = !App.isInIframe();

        bus.$on('toast', (value: string, color: string = 'green') => {
            this.$toast(value, {
                color: color,
                dismissable: true
            });
        });
        this.initDarkMode();
    }

    private initDarkMode() {
        const darkMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        darkMediaQuery.addEventListener('change', (e) => {
        });
    }

    public logout() {
        AuthService.handleLogout();
    }

    private static isInIframe(): boolean {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    }

}
